var map = {
	"./arrow-left.svg": 123,
	"./arrow-right.svg": 124,
	"./arrow-special-full.svg": 125,
	"./arrow-special-left-black.svg": 126,
	"./arrow-special-left-old.svg": 127,
	"./arrow-special-left.svg": 128,
	"./arrow-special-right.svg": 129,
	"./arrow-special-rightdown.svg": 130,
	"./asterisk.svg": 131,
	"./close.svg": 60,
	"./heart.svg": 132,
	"./mail.svg": 133,
	"./menu-close.svg": 134,
	"./menu-open.svg": 135,
	"./social-facebook.svg": 136,
	"./social-instagram.svg": 137,
	"./social-medium.svg": 138,
	"./social-twitter.svg": 139,
	"./url.svg": 140
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 306;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons nonrecursive \.svg$
// module id = 306
// module chunks = 241 242 243